import { getModernTableStyles } from "./modernTableStyles";
import { COLORS } from "./Paymenthistoryconstants";

export const PAYMENT_LINK_SCOPE = "payment-links-modern";

/** Ödeme Linkleri ekranının stilleri: ortak liste stilleri + ekrana özgü birkaç kural. */
export const getPaymentLinkStyles = () => `
  ${getModernTableStyles(PAYMENT_LINK_SCOPE)}

  /* Silinmiş satır: yalnız süper admin görür. Arşiv kaydı canlı linklerle
     karışmasın diye soluk gösterilir. Solukluk opacity ile değil doğrudan
     renkle veriliyor; opacity satırdaki durum rozetlerini de okunmaz yapıyordu. */
  .${PAYMENT_LINK_SCOPE} .table tbody tr.row-deleted > * { background: #fafbfc; color: #98a2b3; }
  .${PAYMENT_LINK_SCOPE} .table tbody tr.row-deleted .text-dark { color: #98a2b3 !important; }
  .${PAYMENT_LINK_SCOPE} .table tbody tr.row-deleted > *:first-child { box-shadow: inset 3px 0 0 #cbd2dc; }

  /* Hızlı filtre rozetleri */
  .${PAYMENT_LINK_SCOPE} .quick-filter {
    display: inline-flex; align-items: center; gap: .4rem;
    padding: .45rem .9rem; border-radius: 999px;
    border: 1px solid #e6eaf0; background: #fff; color: #4B5563;
    font-size: .85rem; font-weight: 600; white-space: nowrap;
    transition: border-color .15s ease, background .15s ease, color .15s ease;
  }
  .${PAYMENT_LINK_SCOPE} .quick-filter:hover { border-color: ${COLORS.NAVY}; color: ${COLORS.NAVY}; }
  .${PAYMENT_LINK_SCOPE} .quick-filter.active {
    background: #E7EEF8; border-color: ${COLORS.NAVY}; color: ${COLORS.NAVY};
  }
  .${PAYMENT_LINK_SCOPE} .quick-filter-count {
    background: #eef1f5; color: #6c757d; border-radius: 999px;
    padding: 0 .45rem; font-size: .75rem; min-width: 22px; text-align: center;
  }
  .${PAYMENT_LINK_SCOPE} .quick-filter.active .quick-filter-count { background: #fff; color: ${COLORS.NAVY}; }
  .${PAYMENT_LINK_SCOPE} .quick-filter-bar { overflow-x: auto; scrollbar-width: thin; }

  /* Grafikli özet kartı */
  .${PAYMENT_LINK_SCOPE} .link-stat-card {
    display: flex; flex-direction: column; gap: .25rem; height: 100%;
    border: 1px solid #e9ecef; border-radius: 1rem;
    padding: 1rem 1.1rem .5rem; background: #fff;
    box-shadow: 0 1px 2px rgba(0,0,0,.04);
    transition: box-shadow .2s ease;
  }
  .${PAYMENT_LINK_SCOPE} .link-stat-card:hover { box-shadow: 0 2px 4px rgba(0,0,0,.08); }
  .${PAYMENT_LINK_SCOPE} .link-stat-head { display: flex; align-items: center; gap: .6rem; }
  .${PAYMENT_LINK_SCOPE} .link-stat-trend {
    display: flex; align-items: center; gap: .3rem; font-size: .75rem; color: #8a94a6;
  }
  .${PAYMENT_LINK_SCOPE} .link-stat-trend .up { color: #2E7D32; font-weight: 600; }
  .${PAYMENT_LINK_SCOPE} .link-stat-trend .down { color: #B42318; font-weight: 600; }
  .${PAYMENT_LINK_SCOPE} .link-stat-spark { margin-top: auto; margin-inline: -.35rem; min-height: 46px; }

  @media (max-width: 576px) {
    .${PAYMENT_LINK_SCOPE} .link-stat-card { padding: .75rem .85rem .35rem; }
    .${PAYMENT_LINK_SCOPE} .link-stat-card .mini-stat-amount { font-size: 1.05rem; }
  }

  /* Sıralanabilir kolon başlığı */
  .${PAYMENT_LINK_SCOPE} .sort-th {
    border: 0; background: transparent; padding: 0; font: inherit; color: inherit;
    display: inline-flex; align-items: center; gap: .3rem;
  }
  .${PAYMENT_LINK_SCOPE} .sort-th:hover { color: ${COLORS.NAVY}; }
  .${PAYMENT_LINK_SCOPE} .sort-th i { font-size: 1rem; }

  /* .link-url kaldırıldı: tablodaki "Ödeme Linki" sütunu ile birlikte kullanımı kalmadı. */
  .${PAYMENT_LINK_SCOPE} .icon-btn {
    border: 0; background: transparent; color: #8a94a6;
    padding: .15rem .3rem; border-radius: .4rem; line-height: 1;
  }
  .${PAYMENT_LINK_SCOPE} .icon-btn:hover { background: #eef1f5; color: ${COLORS.NAVY}; }

  /* Panelde link adresi kutusu */
  .${PAYMENT_LINK_SCOPE} .pd-url-box {
    display: flex; align-items: center; gap: .5rem;
    border: 1px solid #eef1f5; border-radius: .75rem;
    padding: .5rem .75rem; background: #fbfcfe; margin-bottom: 1rem;
  }
  .${PAYMENT_LINK_SCOPE} .pd-url-box span {
    flex: 1 1 auto; font-size: .8rem; color: #4B5563;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }

  /* Paylaşım popover'ı */
  .share-popover { border-radius: 12px; border: 1px solid rgba(0,0,0,.06); box-shadow: 0 6px 18px rgba(0,0,0,.08); }
  .share-popover .popover-body { min-width: 220px; }
`;

export default getPaymentLinkStyles;
